<template>
  <div
    class="record-popup record-with-photo popup parking-record is-long"
    v-show="open"
  >
    <div class="modal-overlay" @click="hide" />
    <v-menu
      absolute
      attach
      :value="!popup"
      :close-on-content-click="false"
      :close-on-click="false"
      content-class="modal-content"
    >
      <div class="d-flex justify-space-between align-center pb-2">
        <h3 class="main-title mr-auto">
          {{ $t("parking_record") }}
          <span v-if="formType === 1"
            >-
            {{
              hrec.parking.completed
                ? $t("parking_history_tabs[1]")
                : $t("parking_history_tabs[0]")
            }}</span
          >
        </h3>
        <v-btn text class="icon-close pa-0" min-width="24px" @click="hide" />
      </div>
      <div class="d-flex flex-wrap record-tabs">
<!--        <div v-if="isSpot" class="photo mr-md-6">-->
<!--          <ZoomOnHover v-if="hrec.photo" scale="2.5" :img-normal="hrec.photo" />-->
<!--          &lt;!&ndash; <img v-if="hrec.photo" :src="`${hrec.photo}`" style="width: 100%" /> &ndash;&gt;-->
<!--          <v-skeleton-loader type="image" v-else />-->
<!--        </div>-->

        <v-tabs v-model="tab" class="mx-0 record-tabs justify-center">
          <v-tab
            class="mx-0"
            v-for="(item, index) in tabs"
            :key="index"
            >{{ item }}
          </v-tab>

          <v-tab-item>
            <div class="parking-record-block">
              <v-text-field
                :readonly="editable === false"
                class="modal-input mb-3 mt-0"
                @input="plateFormatter"
                :value="hrec.car.plate_number"
                :label="$t('car_plate')"
              />

              <v-text-field
                  v-if="$store.getters['app/features'][0]?.usdot"
                  v-model="hrec.parking.usdot_number"
                  :readonly="editable === false"
                  class="modal-input mb-3 mt-0"
                  label="USDOT"
              />

              <v-select
                v-if="$store.getters['app/isUspace']"
                v-model="spaceId"
                :no-data-text="$t('no_data')"
                clearable
                item-value="space_id"
                item-text="space_name"
                class="modal-input my-0"
                :items="$store.state.app.places[0].parking_spaces"
                :label="$t('space')"
              />

              <v-checkbox
                v-if="$store.getters['app/isUspace']"
                :label="$t('manual_update')"
                :input-value="is_manual_control"
                @change="($e) => is_manual_control = $e"
                class="filter-checkbox"
              />

              <!-- DATES -->
              <div class="d-flex record-date-fields-wrapper">
                <div class="d-flex flex-column record-date">
                  <div class="desc-text py-1">
                    <span>{{ $t("date_in") }}: </span>
                    <b v-if="parkingDates.enter_time">{{
                        $moment(parkingDates.enter_time).format("DD.MM.YYYY [at] HH:mm")
                      }}</b>
                    <div class="form-period date single mt-2">
                      <v-menu
                        content-class="datepicker-menu"
                        attach
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :disabled="editable === false"
                            v-on="on"
                            class="modal-input input-half datepicker-inp mt-0"
                            :value="
                          parkingDates.enter_time
                            ? $moment(parkingDates.enter_time).format(
                                'DD.MM.YYYY [at] HH:mm'
                              )
                            : ''
                        "
                            @change="timeChangeHandler(`enter`, $event)"
                            :label="$t('from')"
                            placeholder="DD.MM.YYYY HH:mm"
                          ></v-text-field>
                        </template>

                        <v-tabs fixed-tabs v-model="dates.enter.tab" class="picker-tabs">
                          <v-tab key="calendar">
                            <img src="@/assets/images/calendar.svg" />
                          </v-tab>
                          <v-tab key="timer">
                            <img width="24px" height="24px" src="@/assets/images/clock.svg" />
                          </v-tab>
                          <v-tab-item key="calendar">
                            <v-date-picker
                              :locale="$i18n.locale"
                              first-day-of-week="1"
                              @change="dates.enter.tab = 1"
                              v-model="dates.enter.date"
                              :max="$moment().format('YYYY-MM-DD')"
                            ></v-date-picker>
                          </v-tab-item>
                          <v-tab-item key="timer">
                            <vue-timepicker
                              format="HH:mm:ss"
                              manual-input
                              v-model="dates.enter.time"
                              blur-delay="5000000"
                            />
                          </v-tab-item>
                        </v-tabs>
                      </v-menu>
                    </div>
                  </div>
                  <div class="record-photo-wrapper">
                    <img v-if="photoUrlEntrance" class="record-photo" :src="photoUrlEntrance" />
                    <div v-else class="record-photo record-photo--no-photo" />
                  </div>
                </div>
                <div class="d-flex flex-column record-date">
                  <div class="desc-text py-1">
                    <span>{{ $t("date_out") }}: </span>
                    <b v-if="parkingDates.exit_time">{{
                        $moment(parkingDates.exit_time).format("DD.MM.YYYY [at] HH:mm")
                      }}</b>
                    <div class="form-period date single mt-2">
                      <v-menu
                        content-class="datepicker-menu"
                        attach
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :disabled="editable === false"
                            v-on="on"
                            class="modal-input input-half datepicker-inp mt-0"
                            @change="timeChangeHandler(`exit`, $event)"
                            :value="
                          parkingDates.exit_time
                            ? $moment(parkingDates.exit_time).format(
                                'DD.MM.YYYY [at] HH:mm'
                              )
                            : ''
                        "
                            :label="$t('to')"
                            placeholder="DD.MM.YYYY HH:mm"
                          ></v-text-field>
                        </template>

                        <v-tabs fixed-tabs v-model="dates.exit.tab" class="picker-tabs">
                          <v-tab key="calendar">
                            <img src="@/assets/images/calendar.svg" />
                          </v-tab>
                          <v-tab key="timer">
                            <img width="24px" height="24px" src="@/assets/images/clock.svg" />
                          </v-tab>
                          <v-tab-item key="calendar">
                            <v-date-picker
                              :locale="$i18n.locale"
                              first-day-of-week="1"
                              @change="dates.exit.tab = 1"
                              v-model="dates.exit.date"
                              :max="$moment().format('YYYY-MM-DD')"
                            ></v-date-picker>
                          </v-tab-item>
                          <v-tab-item key="timer">
                            <vue-timepicker
                              format="HH:mm:ss"
                              manual-input
                              v-model="dates.exit.time"
                              blur-delay="5000000"
                            />
                          </v-tab-item>
                        </v-tabs>
                      </v-menu>
                    </div>
                  </div>
                  <div class="record-photo-wrapper">
                    <img v-if="photoUrlExit" class="record-photo" :src="photoUrlExit" />
                    <div v-else class="record-photo record-photo--no-photo" />
                  </div>
                </div>

              </div>

              <!-- </div> -->

              <template>
                <!-- PLACE -->
                <v-select
                  :no-data-text="$t('no_data')"
                  v-if="$store.getters['app/isCompany']"
                  attach
                  v-model="hrec.place.place_id"
                  item-value="place_id"
                  item-text="name"
                  class="modal-input my-0"
                  :items="places"
                  :label="$t('place')"
                />

                <!-- STATUS AND DURATION AND TOTAL PRICE -->
                <div
                  class="d-flex align-center desc-text flex-wrap record-total"
                  v-if="formType === 1"
                >
                  <div v-if="hrec.parking.guest_type === 4">
                    <span>{{ $t("total") }}: </span>
                    <b>
                      {{
                        hrec.parking.total_price
                          ? hrec.parking.currency + hrec.parking.total_price / 100
                          : "0"
                      }}</b
                    >
                  </div>
                  <div>
                    <span>{{ $t("duration") }}: </span>
                    <b>{{ getDuration(hrec.parking) }}</b>
                  </div>
                </div>
                <div v-if="availableRemarks" class="remark">
                  <v-select
                    :no-data-text="$t('no_data')"
                    attach
                    clearable
                    :value="hrec.parking?.parking_gate_control_remark?.type"
                    @change="changeRemarkType"
                    item-value="type"
                    item-text="text"
                    class="modal-input remark-type"
                    :items="remarks"
                    :label="$t('remark')"
                  />
                  <v-text-field
                    v-if="hrec.parking?.parking_gate_control_remark?.type === 'other'"
                    v-model="hrec.parking.parking_gate_control_remark.comment"
                    :label="$t(`comment`)"
                    class="modal-input"
                  />
                </div>
                <v-checkbox
                  v-if="isGoldin || isParkside"
                  :label="$t('unloading')"
                  :input-value="hrec.parking.is_unloading"
                  @change="($e) => hrec.parking.is_unloading = $e"
                  class="filter-checkbox"
                />
              </template>
              <template v-if="hrec.parking.parking_id && hasPaidCash">
                <div class="d-flex justify-space-between align-center desc-text">
                  <v-checkbox
                    :label="$t('parking_cash')"
                    :disabled="isFree"
                    :input-value="isCash"
                    @change="($e) => paymentMethodHandler($e, 'cash')"
                    class="filter-checkbox"
                    :class="hrec.parking.payment_method === 2 ? 'active' : ''"
                  />
                  <v-text-field
                    :value="hrec.parking.total_price / 100 || null"
                    @change="priceChangeHandler"
                    :label="$t(`total`)"
                    class="modal-input input-half"
                    :disabled="hrec.parking.payment_method !== 2"
                  />
                </div>
                <div class="d-flex justify-space-between align-center desc-text mb-4">
                  <v-checkbox
                    :label="$t('parking_free')"
                    :disabled="isCash"
                    :input-value="isFree"
                    @change="($e) => paymentMethodHandler($e, 'free')"
                    class="filter-checkbox"
                    :class="hrec.parking.payment_method === 2 ? 'active' : ''"
                  /></div
              ></template>
              <!-- <div class="border-btm mt-2 mx-n1" /> -->
            </div>
            <div class="d-flex align-center my-3" v-if="hasEditRight">
              <v-btn v-if="editable" @click="saveRecordInfo" class="main-btn px-6 py-2" text>{{
                  $t("save")
                }}</v-btn>
              <v-btn v-if="!isDeleteForbidden" @click="deleteRecord" class="flat-btn" text>{{ $t("delete") }}</v-btn>
            </div>
            <div class="d-flex flex-wrap align-center my-3 record-button-wrapper">
              <v-btn
                :loading="loading"
                v-if="record.parking.receipt_printable"
                class="main-btn py-2 my-3 record-button"
                text
                @click="confirmReprintReceipt"
              >
                {{ $t(`reprint_receipt`) }}
              </v-btn>
              <v-btn
                :loading="loading"
                v-else-if="hasCSPayment"
                style="min-width: 100%"
                class="main-btn py-2 ml-auto my-3 record-button"
                text
                @click="openCheckout"
              >
                <template v-if="isItt || isGoldin">{{ $t(`checkout`) }}</template>
                <template v-else>{{ $t(`price_check`) }}</template>
              </v-btn>
              <v-btn
                :loading="loading"
                v-if="record?.payment?.receipt_id"
                class="main-btn py-2 my-3 record-button"
                text
                @click="copyReceiptLink"
              >
                {{
                  isCopied
                    ? $t(`copied`)
                    : isCopyError
                      ? $t(`error_short`)
                      : $t(`copy_receipt_link`)
                }}
              </v-btn>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="parking-record-block">
              <v-text-field
                :readonly="editable === false"
                class="modal-input mb-3 mt-0"
                @input="plateFormatter"
                :value="hrec.car.plate_number"
                :label="$t('car_plate')"
              />
              <v-select
                :no-data-text="$t('no_data')"
                :readonly="editable === false"
                class="modal-input my-3"
                attach
                v-model="hrec.car.car_type"
                item-value="id"
                item-text="desc"
                :items="carTypes"
                :label="$t('car_type')"
              />

              <v-text-field
                :readonly="editable === false"
                class="modal-input my-3"
                v-model="hrec.car.color"
                :label="$t('car_color')"
              />
              <v-combobox
                :readonly="editable === false"
                attach
                v-model="hrec.car.brand"
                class="modal-input my-3"
                :items="getCarBrands(hrec.car.brand)"
                :label="$t('car_brand')"
              />
            </div>
            <div class="d-flex align-center my-3" v-if="hasEditRight">
              <v-btn v-if="editable" @click="saveRecordInfo" class="main-btn px-6 py-2" text>{{
                  $t("save")
                }}</v-btn>
              <v-btn v-if="!isDeleteForbidden" @click="deleteRecord" class="flat-btn" text>{{ $t("delete") }}</v-btn>
            </div>
            <div class="d-flex flex-wrap align-center my-3 record-button-wrapper">
              <v-btn
                :loading="loading"
                v-if="record.parking.receipt_printable"
                class="main-btn py-2 my-3 record-button"
                text
                @click="confirmReprintReceipt"
              >
                {{ $t(`reprint_receipt`) }}
              </v-btn>
              <v-btn
                :loading="loading"
                v-else-if="hasCSPayment"
                style="min-width: 100%"
                class="main-btn py-2 ml-auto my-3 record-button"
                text
                @click="openCheckout"
              >
                <template v-if="isItt || isGoldin">{{ $t(`checkout`) }}</template>
                <template v-else>{{ $t(`price_check`) }}</template>
              </v-btn>
              <v-btn
                :loading="loading"
                v-if="record?.payment?.receipt_id"
                class="main-btn py-2 my-3 record-button"
                text
                @click="copyReceiptLink"
              >
                {{
                  isCopied
                    ? $t(`copied`)
                    : isCopyError
                      ? $t(`error_short`)
                      : $t(`copy_receipt_link`)
                }}
              </v-btn>
            </div>
          </v-tab-item>

          <v-tab-item v-if="isKioskCheckoutAvailable" class="send-to-kiosk-wrapper">
            {{ $t("calculation_total") }}
            <v-text-field
              v-model="kioskCheckoutUserAmount"
              @blur="handleBlurKioskCheckoutAmount"
              :disabled="!isKioskCheckoutAmountLoaded"
              class="modal-input mb-3 mt-0"
            />
            <v-btn
              @click="confirmSendToKiosk"
              :disabled="!isKioskCheckoutAmountLoaded || !kioskCheckoutUserAmount"
              text
              class="main-btn px-6 py-2"
            >
              {{ $t("send_to_kiosk") }}
            </v-btn>
          </v-tab-item>
          <v-tab-item v-if="scanAndPayHostURL" class="send-to-kiosk-wrapper">
            {{ $t("calculation_total") }}
            <v-text-field
              v-model="scanAndPayCheckoutUserAmount"
              @blur="handleBlurScanAndPayCheckoutAmount"
              :disabled="!isKioskCheckoutAmountLoaded"
              class="modal-input mb-3 mt-0"
            />
            <v-btn
              @click="copyScanAndPayLink"
              :disabled="!isKioskCheckoutAmountLoaded || !kioskCheckoutUserAmount || isLoadingScanAndPay"
              text
              class="main-btn px-6 py-2"
            >
              {{
                isCopiedScanAndPay
                  ? $t(`copied`)
                  : isCopiedScanAndPayError
                    ? $t(`error_short`)
                    : $t(`copy_payment_link`)
              }}
            </v-btn>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-menu>
    <div class="checkout-wrapper">
      <Checkout
        :record="hrec"
        v-show="popup === 'checkout'"
        @hide="exitPopup"
        @openCSChannel="openCSChannel"
      />
      <LoadingPopup v-if="connectStatus === 'connecting'" />
      <div v-show="connectStatus === 'connected'">
        <OctopusTransactions
          v-show="popup === 'transactions'"
          @hide="exitPopup"
        />
        <OctopusFlow @hide="exitPopup" v-show="popup === 'octopus'" ref="octopusFlow" />
      </div>
      <div v-if="connectStatus === 'error'" class="popup record-popup" style="z-index: 20; max-width: 420px">
        <div class="modal-overlay" style="opacity: 0.16" @click="connectStatus = ''" />
        <div class="modal-content">
          <h2 v-html="$t('error')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { base } from "@/axios-api";
import { Centrifuge } from "centrifuge";
const CENTR_HOST = "wss://api.parkingbnb.world/tv/centrifugo/connection/websocket";

import carBrandsDb from "@/assets/cars/carModels.json";
import EventBus from '@/event-bus';
import { formatPlate } from "@/common/helpers/helpers";

const defaultDates = {
  enter: {
    tab: 0,
    date: "",
    time: {
      HH: undefined,
      mm: undefined,
      ss: undefined,
    },
  },
  exit: {
    tab: 0,
    date: "",
    time: {
      HH: undefined,
      mm: undefined,
      ss: undefined,
    },
  },
};

export default {
  name: "ParkingRecordPopupWithPhoto",
  props: {
    record: {
      default() {
        return {
          parking: { guest_type: undefined, usdot_number: undefined },
          place: {},
          user: {},
          car: {},
        };
      },
    },
  },
  components: {
    VueTimepicker: () => import("vue2-timepicker/src/vue-timepicker.vue"),
    Checkout: () => import("./Checkout.vue"),
    OctopusTransactions: () => import("@/components/Wallet/OctopusTransactions.vue"),
    OctopusFlow: () => import("@/components/Wallet/OctopusFlow.vue"),
    LoadingPopup: () => import("@/components/core/LoadingPopup"),
  },
  data() {
    return {
      loading: false,
      tab: 0,
      open: false,
      editing: false,
      dates: JSON.parse(JSON.stringify(defaultDates)),
      isCash: false,
      isFree: false,
      hrec: {
        car: {},
        parking: { guest_type: undefined, is_unloading: false },
        user: {},
        place: {},
      },
      spaceId: null,
      is_manual_control: false,
      //CHECKOUT
      centrifuge: null,
      popup: "",
      kioskCheckoutUserAmount: "",
      scanAndPayCheckoutUserAmount: "",
      isCopied: false,
      isCopiedScanAndPay: false,
      isCopiedScanAndPayError: false,
      isCopyError: false,
      isLoadingScanAndPay: false,
      connectStatus: '',
    };
  },
  computed: {
    remarks() {
      return this.availableRemarks?.map((remark) => ({
        type: remark,
        text: this.$t(`remark_type.${remark}`),
      }))
    },
    kioskCheckoutAmount() {
      return this.$store.state.history.kioskCheckoutAmount;
    },
    isKioskCheckoutAmountLoaded() {
      return this.$store.state.history.isKioskCheckoutAmountLoaded;
    },
    isKioskCheckoutAvailable() {
      return this.hrec.parking.kiosk_checkout_available;
    },
    scanAndPayHostURL() {
      return this.$store.state.app.places[0]?.features?.scanAndPay;
    },
    tabs() {
      const tabs = [this.$t(`parking_info`), this.$t(`car_info`)];
      if (this.isKioskCheckoutAvailable) {
        tabs.push(this.$t(`kiosk`));
      }
      if (this.scanAndPayHostURL && this.record?.parking?.parking_id) {
        tabs.push(this.$t(`online_link`));
      }
      return tabs;
    },
    isCustomerService() {
      return this.$store.getters["app/isCustomerService"];
    },
    photoUrlEntrance() {
      if (Object.keys(this.record.parking).includes("entrance")) {
        return this.record.parking.entrance.photo_url;
      } else {
        return "";
      }
    },
    photoUrlExit() {
      if (Object.keys(this.record.parking).includes("exit")) {
        return this.record.parking.exit.photo_url;
      } else {
        return "";
      }
    },
    // isSpot() {
    //   return this.$store.getters["app/isSpot"];
    // },
    isItt() {
      return this.$store.getters["app/isItt"];
    },
    isGoldin() {
      return this.$store.getters["app/isGoldin"];
    },
    isParkside() {
      return this.$store.getters["app/isParkside"];
    },
    isDeleteForbidden() {
      return this.$store.getters["app/isEnaconAdmin"];
    },
    availableRemarks() {
      return this.$store.state.app.places[0]?.features?.gateControlRemark;
    },
    hasEditRight() {
      return this.$store.getters["app/hasHistoryEditRight"];
    },
    parkingDates() {
      let enterString = `${this.dates.enter.date} ${this.dates.enter.time.HH}:${this.dates.enter.time.mm}:${this.dates.enter.time.ss}`.replaceAll(
        "undefined",
        ""
      );
      let exitString = `${this.dates.exit.date} ${this.dates.exit.time.HH}:${this.dates.exit.time.mm}:${this.dates.exit.time.ss}`.replaceAll(
        "undefined",
        ""
      );
      if (enterString.length < 19) enterString = "";
      else enterString = this.$moment(enterString).toISOString();

      if (exitString.length < 19) exitString = "";
      else exitString = this.$moment(exitString).toISOString();

      return {
        enter_time: enterString,
        exit_time: exitString,
      };
    },
    formType() {
      return Number(!!this.hrec.parking.parking_id);
    },
    places() {
      return [...this.$store.state.app.places].map((p) => {
        return { ...p, name: p.place_name };
      });
    },
    locale() {
      return this.$store.getters["app/locale"];
    },
    hasSimpleHistory() {
      return this.$store.getters["app/hasSimpleHistory"];
    },
    carTypes() {
      let types = [];
      let ids = [...this.$store.state.app.car_types];
      ids
        .filter((i) => i.id !== 0)
        .map((id) => {
          types.push({ id, desc: this.$t(`car_types[${id}]`) });
        });
      return types;
    },
    hasPaidCash() {
      return (
        this.record.parking.guest_type === 10 ||
        (this.record.parking.guest_type === 5 &&
          this.$store.getters["app/hasOfflinePayment"]) ||
        this.isBV
      );
    },
    hasCSPayment() {
      return (
        this.$store.getters["app/isItt"] || this.$store.getters["app/isGoldin"] || this.$store.getters["app/hasCalculation"]
      );
      // return true;
    },
    editable() {
      return true;
    },
    isBV() {
      return this.$store.getters["app/isBV"];
    },
    token() {
      return this.$store.state.app.cs_token;
    },
    refreshToken() {
      return this.$store.state.app.cs_refresh_token;
    },
  },
  watch: {
    open(newValue) {
      this.hrec = JSON.parse(JSON.stringify(this.record));

      if (newValue) {
        if (this.isKioskCheckoutAvailable || this.scanAndPayHostURL) {
          this.getKioskCheckoutCalculation({
            parking_id: this.hrec.parking.parking_id,
            guest_type: this.hrec.parking.guest_type,
          });
        }
      } else {
        this.$store.commit('history/set_kiosk_checkout_amount_loaded_status', false);
        this.$store.commit('history/set_kiosk_checkout_amount', 0);
        this.kioskCheckoutUserAmount = "";
        this.scanAndPayCheckoutUserAmount = "";
      }

      if (this.$store.getters['app/isUspace']) {
        if (this.record?.parking_space?.space_id) {
          this.spaceId = this.record.parking_space.space_id;
          this.is_manual_control = this.record.parking.is_manual_control;
        }
      }

      if (this.record && this.record.parking && this.record.parking.enter_time) {
        // if (this.isSpot) {
        //   this.getParkingPic();
        // }

        if (this.record.parking.payment_method === 2) {
          this.isFree = this.record.parking.total_price === 0;
          this.isCash = this.record.parking.total_price > 0;
        }

        let enterString = this.record.parking.enter_time;
        let exitString = this.record.parking.exit_time || "";
        this.dates = {
          enter: {
            tab: 0,
            date: this.$moment(enterString).format("YYYY-MM-DD"),
            time: {
              HH: this.$moment(enterString).format("HH"),
              mm: this.$moment(enterString).format("mm"),
              ss: this.$moment(enterString).format("ss"),
            },
          },
          exit: {
            tab: 0,
            date: this.$moment(exitString).format("YYYY-MM-DD"),
            time: {
              HH: this.$moment(exitString).format("HH"),
              mm: this.$moment(exitString).format("mm"),
              ss: this.$moment(exitString).format("ss"),
            },
          },
        };
      }
    },
  },
  methods: {
    show() {
      this.open = true;
    },
    hide() {
      this.isCopied = false;
      this.isCopyError = false;
      this.isCopiedScanAndPay = false;
      this.isCopiedScanAndPayError = false;
      this.isLoadingScanAndPay = false;
      this.open = false;
      this.dates = JSON.parse(JSON.stringify(defaultDates));
      this.isCash = false;
      this.isFree = false;
      this.loading = false;
      this.spaceId = null;
      this.is_manual_control = false;
      this.hrec = {
        car: {},
        parking: { guest_type: undefined, is_unloading: false },
        user: {},
        place: {},
      };
      if (this.centrifuge) this.centrifuge.disconnect();
      this.exitPopup();
      this.$emit("hide");
      this.$store.commit("wallet/reset_card");
    },
    changeRemarkType(evt) {
      this.hrec.parking.parking_gate_control_remark.comment = '';
      this.hrec.parking.parking_gate_control_remark.type = evt;
    },
    copyReceiptLink() {
      try {
        navigator.clipboard.writeText(
          `https://pay.urbanpass.world/receipt/${this.record.payment.receipt_id}`
        )
          .then(() => {
            this.isCopied = true;
          })
          .catch(() => {
            this.isCopyError = true;
          })
      } catch {
        this.isCopyError = true;
      }
    },
    handleBlurKioskCheckoutAmount() {
      const amount = this.kioskCheckoutUserAmount;
      const regexp = new RegExp('^[0-9\\s]*$');
      const regexpSpaces = new RegExp(/\s/);
      if (
        amount.length &&
        (!regexp.test(amount) || regexpSpaces.test(amount))
      ) {
        this.kioskCheckoutUserAmount = '';
      }
    },
    handleBlurScanAndPayCheckoutAmount() {
      const amount = this.kioskCheckoutUserAmount;
      const regexp = new RegExp('^[0-9\\s]*$');
      const regexpSpaces = new RegExp(/\s/);
      if (
        amount.length &&
        (!regexp.test(amount) || regexpSpaces.test(amount))
      ) {
        this.kioskCheckoutUserAmount = '';
      }
    },
    getKioskCheckoutCalculation(params) {
      this.$store.dispatch('history/getKioskCheckoutCalculation', params)
        .then(() => {
          this.kioskCheckoutUserAmount = this.kioskCheckoutAmount;
          this.scanAndPayCheckoutUserAmount = this.kioskCheckoutAmount;
        });
    },
    confirmReprintReceipt() {
      this.$confirm({
        message: this.$t("confirm_reprint_receipt"),
        button: {
          no: this.$t("cancel"),
          yes: this.$t("reprint"),
        },
        callback: (confirm) => {
          if (confirm) {
            const data = {
              parking_id: this.hrec.parking.parking_id,
              guest_type: this.hrec.parking.guest_type,
            };
            base({
              url: '/payments/receipts/print',
              data,
              method: 'POST',
            })
              .then((response) => {
                if (response.data.code === 100) {
                  EventBus.$emit("notify", {
                    group: 'general',
                    title: 'Success!',
                    duration: 3000
                  })
                } else {
                  EventBus.$emit("notify", {
                    group: 'general',
                    title: 'Error!',
                    duration: 5000
                  })
                }
              })
              .catch(() => {
                EventBus.$emit("notify", {
                  group: 'general',
                  title: 'Error!',
                  duration: 5000
                })
              });
          }
        },
      });
    },
    confirmSendToKiosk() {
      this.$confirm({
        message: this.$t("confirm_send_to_kiosk"),
        button: {
          no: this.$t("cancel"),
          yes: this.$t("yes"),
        },
        callback: (confirm) => {
          if (confirm) {
            const data = {
              parking_id: this.hrec.parking.parking_id,
              guest_type: this.hrec.parking.guest_type,
              forced_price: this.kioskCheckoutUserAmount !== this.kioskCheckoutAmount ? Number(this.kioskCheckoutUserAmount) * 100 : null,
            };
            base({
              url: '/payments/checkout/exit-kiosk',
              data,
              method: 'POST',
            })
              .then((response) => {
                if (response.data.code === 100) {
                  EventBus.$emit("notify", {
                    group: 'general',
                    title: 'Success!',
                    duration: 3000
                  })
                } else {
                  EventBus.$emit("notify", {
                    group: 'general',
                    title: 'Error!',
                    duration: 5000
                  })
                }
              })
              .catch(() => {
                EventBus.$emit("notify", {
                  group: 'general',
                  title: 'Error!',
                  duration: 5000
                })
              });
          }
        },
      });
    },
    copyScanAndPayLink() {
      this.$confirm({
        message: this.$t("confirm_copy_payment_link"),
        button: {
          no: this.$t("cancel"),
          yes: this.$t("yes"),
        },
        copyLink: `${this.scanAndPayHostURL}/scan-and-pay?parkingid=${this.record.parking.parking_id}`,
        callback: (confirm) => {
          if (confirm) {
            this.isLoadingScanAndPay = true;
            const data = {
              parking_id: this.hrec.parking.parking_id,
              guest_type: this.hrec.parking.guest_type,
              forced_price: Number(this.scanAndPayCheckoutUserAmount) * 100
            };
            base({
              url: '/payments/checkout/scan-and-pay',
              data,
              method: 'POST',
            })
              .then((response) => {
                if (response.status === 204) {
                  this.isCopiedScanAndPay = true;
                } else {
                  EventBus.$emit("notify", {
                    group: 'general',
                    title: 'Error!',
                    duration: 5000
                  })
                }
              })
              .catch(() => {
                EventBus.$emit("notify", {
                  group: 'general',
                  title: 'Error!',
                  duration: 5000
                })
              })
              .finally(() => {
                this.isLoadingScanAndPay = false;
              });
          }
        },
      });
    },
    plateFormatter(val) {
      this.hrec.car.plate_number = formatPlate(val);
      this.$forceUpdate();
    },
    getDuration(parking) {
      let duration = this.$moment.duration(parking.duration, "milliseconds");
      let months = duration._data.months ? duration._data.months + "m" : "";
      let days = duration._data.days ? duration._data.days + "d" : "";
      let hours = duration._data.hours ? duration._data.hours + "h" : "";
      let minutes = duration._data.minutes;

      if (duration._data.seconds && duration._data.minutes !== 59) {
        minutes = minutes + 1;
      }

      minutes = minutes + "m";

      return `${months} ${days} ${hours} ${minutes}`;
    },
    getCarBrands(value) {
      if (value !== "" && carBrandsDb[value] && value !== "N/A") {
        return carBrandsDb[value].map((brand) => value + " " + brand);
      } else {
        return Object.keys(carBrandsDb);
      }
    },

    priceChangeHandler(val) {
      this.hrec.parking.total_price = val * 100;
      this.hrec.price_rewrite = true;
    },

    paymentMethodHandler(value, type) {
      if (value) {
        this.hrec.parking.payment_method = 2;
        if (type === "cash") this.isCash = true;
        else this.isFree = true;
      } else {
        this.hrec.parking.payment_method = 0;
        this.isFree = false;
        this.isCash = false;
      }
    },
    timeChangeHandler(type, value) {
      if (!value) {
        this.dates[type].date = null;
        this.dates[type].time = {
          HH: undefined,
          mm: undefined,
          ss: undefined,
        };
        this.$forceUpdate();
        return;
      }
      let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
      let dateString = value.replace(pattern, "$3-$2-$1");
      let date = this.$moment(new Date(dateString)).format("YYYY-MM-DD");
      this.dates[type].date = date;
      this.dates[type].time = {
        HH: value.slice(-5).slice(0, 2),
        mm: value.slice(-2),
        ss: "00",
      };
      this.$forceUpdate();
    },

    deleteRecord() {
      this.$confirm({
        message: this.$t("parking_delete_prompt"),
        button: {
          no: this.$t("cancel"),
          yes: this.$t("confirm"),
        },
        callback: (confirm) => {
          if (confirm) {
            let params = {
              parking_id: this.hrec.parking.parking_id,
              guest_type: this.hrec.parking.guest_type,
            };
            this.$store.dispatch("history/deleteRecord", {
              params,
              notify: true,
            });
            this.hide();
          }
        },
      });
    },

    saveRecordInfo() {
      this.$confirm({
        message: this.$t("save_prompt"),
        button: {
          no: this.$t("cancel"),
          yes: this.$t("save"),
        },
        callback: (confirm) => {
          if (confirm) {
            let data = {
              enter_time: this.$moment(this.parkingDates.enter_time).toISOString(),
              exit_time: this.parkingDates.exit_time
                ? this.$moment(this.parkingDates.exit_time).toISOString()
                : null,
              place_id: this.hrec.place.place_id || this.places[0].place_id,
              guest_type: this.hrec.parking.guest_type,
              plate: this.hrec.car.plate_number,
              car_type: this.hrec.car.car_type,
              car_brand: this.hrec.car.brand,
              color: this.hrec.car.color,
              parking_id: this.hrec.parking.parking_id,
              is_unloading: this.hrec.parking.is_unloading,
            };

            if (this.availableRemarks) {
              data = {
                ...data,
                parking_gate_control_remark: {
                  type: this.hrec.parking?.parking_gate_control_remark?.type,
                  comment: this.hrec.parking?.parking_gate_control_remark?.comment,
                }
              };
            }

            if (this.$store.getters['app/isUspace']) {
              data = {
                ...data,
                space_id: this.spaceId,
                is_manual_control: this.is_manual_control,
              };
            }

            if (this.$store.getters['app/features'][0]?.usdot) {
              data = {
                ...data,
                usdot_number: this.hrec.parking.usdot_number,
              };
            }

            if (this.formType === 0) {
              this.$store.dispatch("history/addRecord", { data, type: 1 });
            } else {
              this.$store.dispatch("history/updateRecord", data);
            }

            if (this.hrec.parking.payment_method === 2) {
              let paymentData = {
                parking_id: this.hrec.parking.parking_id,
                guest_type: this.hrec.parking.guest_type,
                price: this.hrec.parking.total_price,
                price_rewrite: this.hrec.price_rewrite || false,
              };
              // console.log(paymentData);
              if (this.isBV) {
                paymentData = {
                  ...paymentData,
                  price: 0,
                  price_rewrite: true,
                };
              }
              this.$store.dispatch("history/setPayment", { data: paymentData });
            }

            this.hide();
          }
        },
      });
    },

    // getParkingPic() {
    //   base({
    //     url: `/history/photo`,
    //     method: "GET",
    //     responseType: "blob",
    //     params: {
    //       parking_id: this.hrec.parking.parking_id,
    //     },
    //   }).then((response) => {
    //     var fileURL = URL.createObjectURL(new Blob([response.data]));
    //     this.hrec.photo = fileURL;
    //     this.$forceUpdate();
    //   });
    // },
    openCheckout() {
      this.$store.dispatch("history/getRecordCalculation", {
        parking_id: this.hrec.parking.parking_id,
        guest_type: this.hrec.parking.guest_type,
      });
      this.popup = "checkout";
    },
    exitPopup(success) {
      this.popup = "";
      this.connectStatus = '';
      if (success) this.hide();
      return success;
    },
    getToken() {
      return new Promise((resolve, reject) => {
        base({
          url: "/auth/token/refresh-centrifugo",
          params: { token: this.refreshToken },
        })
          .then((res) => {
            if (!res.status === 200) {
              throw new Error(`Unexpected status code ${res.status}`);
            }
            let data = res.data.body;
            this.$store.commit("app/cs_auth_success", data);
            // console.log(data.access_token);
            resolve(data.access_token);
          })
          .catch((err) => {
            reject(err);
            this.$store.commit("app/logout");
            // location.reload();
          });
      });
    },
    openCSChannel() {
      this.connectStatus = 'connecting';
      this.popup = "octopus";
      console.log("connect centrifuge");
      if (this.centrifuge && this.centrifuge.state === "connecting") {
        console.log("aborted counter connection");
        return;
      }
      this.centrifuge = new Centrifuge(CENTR_HOST, {
        token: this.token,
        getToken: () => this.getToken(),
      });

      this.centrifuge.connect();
      this.centrifuge.on("connected", (data) => {
        console.log(`connected ${JSON.stringify(data)}`);
        this.connectStatus = 'connected';
      });
      this.centrifuge.on("connecting", (data) => {
        console.log(`connecting ${JSON.stringify(data)}`);
      });
      this.centrifuge.on("error", (err) => {
        console.log(`error ${JSON.stringify(err)}`);
        if (err.error.code === 3500 || err.error.code === 109) {
          // CODE 2 = TRANSPORT CLOSED
          // CODE 3500 = INVALID TOKEN
          // CODE 109 = EXPIRED TOKEN
          if (!this.connecting && this.$store.getters["app/authorized"]) {
            console.log("auto relogin");
            this.$store.dispatch("app/counterLogin").then(() => {
              this.openCSChannel();
            });
          }
        } else {
          this.connectStatus = 'error';
        }
      });
      this.centrifuge.on("disconnected", (data) => {
        console.log(`disconnected ${JSON.stringify(data)}`);
      });
      this.centrifuge.on("publication", (data) => {
        let push = data.data;
        // console.log(push);
        this.handlePush(push);
      });
    },
    handlePush(push) {
      console.log(push);
      if (
        push.event === "parking_payment" &&
        push.content.parking_id === this.hrec.parking.parking_id
      ) {
        this.$store.commit("wallet/set_current_push", push.content);
        this.popup = "octopus";
      } else if (push.event === "last_transactions") {
        this.$store.commit("wallet/set_current_card", push.content);
        this.popup = "transactions";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_modal.scss";
</style>

<style lang="scss" scoped>
.v-text-field__details {
  display: none;
}
@media print, screen and (min-width: 576px) {
  .datepicker-menu {
    top: 3.2em !important;
  }
}

.datepicker-menu {
  background-color: #ffffff;
}

.record-popup {
  max-height: 100vh;
  overflow: scroll !important;
}

.modal-content {
  max-height: 100vh;
  //overflow: scroll !important;

  @media print, screen and (max-width: 576px) {
    overflow: scroll !important;
  }
}

.record-tabs {
  width: 100% !important;
}

.record-date-fields-wrapper {
  gap: 15px;

  @media print, screen and (max-width: 736px) {
    flex-direction: column;
  }
}

.record-date {
  width: 100%;
}

.record-photo-wrapper {
  height: 100%;
}

.record-photo {
  text-align: center;
  display: block;
  width: auto;
  max-height: 200px;
  margin: 0 auto;
  max-width: 329px;

  @media print, screen and (max-width: 736px) {
    max-width: 658px;
  }

  &--no-photo {
    background-color: #DDDDDD;
    background-image: url("~@/assets/images/camera-slash.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px;
    height: 100%;
    min-height: 200px;
  }
}

.record-total {
  gap: 15px;
}

.send-to-kiosk-wrapper {
  margin: 30px 0;
}

.record-button-wrapper {
  width: 100%;
  gap: 15px;
}

.record-button {
  padding-left: 30px;
  padding-right: 30px;
  min-width: calc(max(190px, calc(50% - 8px))) !important;
  flex-grow: 1;
  margin: 0;
  max-width: none !important;
}

.remark {
  display: flex;
  flex-direction: column;


  &:has(.menuable__content__active) {
    @media print, screen and (max-width: 767px) {
      margin-bottom: 140px;
    }
  }

  @media print, screen and (min-width: 576px) {
    flex-direction: row;
    gap: 20px;

    .remark-type {
      width: 30%;
    }
  }
}
</style>
